"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    // creates flex classes
    return {
        row: { display: "flex", flexFlow: "row", flexWrap: "nowrap" },
        column: { display: "flex", flexFlow: "column", flexWrap: "nowrap" },
        wrap: { flexWrap: "wrap" },
        noWrap: { flexWrap: "nowrap" },
        itemsStart: { alignItems: "flex-start" },
        itemsCenter: { alignItems: "center" },
        itemsEnd: { alignItems: "flex-end" },
        itemsStretch: { alignItems: "stretch" },
        justifyStart: { justifyContent: "flex-start" },
        justifyCenter: { justifyContent: "center" },
        justifyEnd: { justifyContent: "flex-end" },
        justifyBetween: { justifyContent: "space-between" },
        justifyEvenly: { justifyContent: "space-evenly" },
        justifyStretch: { justifyContent: "stretch" },
        selfStart: { alignSelf: "flex-start" },
        selfCenter: { alignSelf: "center" },
        selfEnd: { alignSelf: "flex-end" },
        selfStretch: { alignSelf: "stretch" },
        flexGrow: { flexGrow: 1 },
        flexShrink: { flexShrink: 1 }
    };
});
//# sourceMappingURL=Flex.js.map